<div class="tempoRastro">
  <div>
    <h3> {{ 'COMPONENTS.MAPA.DIALOGS.PLANTING_FAILURES.title' | transloco }} </h3>
    <div class="progress-container">
      <div class="progress-bar-wrapper">
        <app-loading
          style="margin-top: 1rem;"
          *ngIf="carregandoFalhas"
          [height]="1.7"
          [colunas]="1"
          [linhas]="1"
          cor="#e6e4e4">
        </app-loading>

        <div class="progress-segments" *ngIf="!carregandoFalhas">
          <div
            *ngFor="let plantioFalha of plantiosFalhas"
            class="segment"
            [style.width.%]="plantioFalha.porcentagem"
            [matTooltip]="plantioFalha.porcentagem + '% (' + plantioFalha.hectares + ')'"
            matTooltipPosition="above"
            [style]="'--cor-rastro:' + coresRastros[plantioFalha.tipo]">

            <span [hidden]="plantioFalha.porcentagem / 100 * 368 < 10.8 * plantioFalha.hectares.length">
              {{ plantioFalha.porcentagem }}%
              ({{ plantioFalha.hectares }})
            </span>
          </div>
        </div>
      </div>

      <div class="legenda">
        <div class="legenda coluna">
          <div class="legenda item">
            <span class="legenda cor plantado"></span>
            <span class="legenda texto"> {{ 'COMPONENTS.MAPA.DIALOGS.PLANTING_FAILURES.planted' | transloco }} </span>
          </div>
        </div>

        <div class="legenda coluna">
          <div class="legenda item">
            <span class="legenda cor falha"></span>
            <span class="legenda texto"> {{ 'COMPONENTS.MAPA.DIALOGS.PLANTING_FAILURES.failure' | transloco }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>